import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { tap, filter, debounceTime } from 'rxjs/operators';

@Component({
	selector: 'app-reveal',
	templateUrl: './reveal.component.html',
	styleUrls: ['./reveal.component.scss']
})
export class RevealComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('revealForm', { static: true }) revealForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	formSubscription: Subscription;
	linkFocus;
	fallbackImgUrl: string;
	isAdmin;

	constructor(private cs: ComponentService, private auth: AuthService) {}

	ngOnInit() {
		if (!this.componentData.config.use_external) {
			this.componentData.config.use_external = {};
			this.componentData.config.use_external.image = false;
			this.componentData.config.use_external.add_image_tracking = false;
			this.componentData.config.use_external.link = false;
			this.componentData.config.use_external.add_link_tracking = false;
		}

		this.isAdmin = this.auth.isAdmin();

		this.fallbackImgUrl =
			this.componentData &&
			this.componentData.config &&
			this.componentData.config.fallback_image &&
			this.componentData.config.fallback_image.image_url
				? this.componentData.config.fallback_image.image_url
				: '';

		this.formSubscription = this.revealForm.valueChanges
			.pipe(
				tap(() =>
					this.cs.updateDisabledSave((this.revealForm.dirty && this.revealForm.invalid) || this.nameField.editComponentName)
				),
				filter((data) => Boolean(this.revealForm.dirty && this.revealForm.valid)),
				tap(() => this.cs.updateComponentData(this.componentData)),
				debounceTime(1000)
			)
			.subscribe(
				(error) => {
					this.cs.updateDisabledSave(false);
				},
				() => {}
			);
	}

	ngOnDestroy() {
		this.formSubscription.unsubscribe();
	}

	renderWidget(): void {
		this.cs.updateComponentData(this.componentData);
		this.cs.updatePreviewData();
	}

	onFallbackImgUrlChange($event) {
		this.fallbackImgUrl = $event;
		if (this.fallbackImgUrl && this.fallbackImgUrl.length) {
			this.componentData.config = Object.assign({}, this.componentData.config, {
				fallback_image: {
					image_url: $event
				}
			});
		} else {
			delete this.componentData.config.fallback_image;
		}
	}
}
